// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/app'
import { Route as AnotherPageRouteImport } from './routes/anotherPage'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WWorkspaceIdRouteImport } from './routes/w/$workspaceId'
import { Route as PublishSlugRouteImport } from './routes/publish/$slug'
import { Route as DDocIdRouteImport } from './routes/d/$docId'

const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const AnotherPageRoute = AnotherPageRouteImport.update({
            id: '/anotherPage',path: '/anotherPage',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const WWorkspaceIdRoute = WWorkspaceIdRouteImport.update({
            id: '/w/$workspaceId',path: '/w/$workspaceId',getParentRoute: () => rootRouteImport
          })
const PublishSlugRoute = PublishSlugRouteImport.update({
            id: '/publish/$slug',path: '/publish/$slug',getParentRoute: () => rootRouteImport
          })
const DDocIdRoute = DDocIdRouteImport.update({
            id: '/d/$docId',path: '/d/$docId',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AnotherPageRoute: AnotherPageRoute,AppRoute: AppRoute,DDocIdRoute: DDocIdRoute,PublishSlugRoute: PublishSlugRoute,WWorkspaceIdRoute: WWorkspaceIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)